import scssVariables from 'styles/sass-variables.module.scss';

export const backButtonStyle: Record<string, string | object> = {
  width: 'fit-content',
  minWidth: '24px',
  minHeight: '24px',
  boxSizing: 'border-box',
  padding: '0px',
  color: `${scssVariables.text_grey}`,
  fontWeight: '400',
  ':hover': {
    backgroundColor: 'transparent',
  },
};
